import angular from 'angular';

import AccountSettingsModule from './account';
import DataSettingsModule from './data';
import GeneralSettingsModule from './general';
import UserInterfaceSettingsModule from './user-interface';
import SubscriptionSettingsModule from './subscription';
import AboutSettingsModule from './about';

export default angular
    .module('application.scene.authorized.scene.settings.scene', [
        AccountSettingsModule.name,
        DataSettingsModule.name,
        GeneralSettingsModule.name,
        UserInterfaceSettingsModule.name,
        SubscriptionSettingsModule.name,
        AboutSettingsModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/index.js